import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavItem, NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { externalHealthDashboardRouter } from './routing/externalHealthDashboardRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { externalHealthDashboardAccessControl } from './access-control/externalHealthDashboardAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'external-health-dashboard',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'external-health-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    scoped: [externalHealthDashboardRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Admin,
      subNavItems: [
        {
          type: 'item',
          labelId: 'externalHealthDashboardDomain.partnerStatus.nav.title',
          llmDescription: 'Navigate to the partner status dashboard',
          route: 'external-health-dashboard-partner-status',
          accessControl: externalHealthDashboardAccessControl,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
  // NOTE TO DEV: run `yarn ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
